// Page / device / network context. Sampled once at init and refreshed on
// (a) SPA route change and (b) flush time so a long-lived session reflects
// network type swaps (wifi -> cellular). The refresh is intentionally cheap:
// no layout-triggering reads.

import { supports, safely } from './safe.js';

let _appCfg = null;

export function initContext(cfg) {
  _appCfg = cfg;
}

export function snapshot(routeName, viewId) {
  const c = {
    appId: _appCfg.appId,
    environment: _appCfg.environment,
    release: _appCfg.release,

    url: location.href,
    referrer: document.referrer || '',
    routeName: routeName || '',

    userAgent: navigator.userAgent || '',
    userAgentHints: collectUaHints(),

    locale: getLocale(),
    timezone: getTimezone(),

    viewportWidth:  (window.innerWidth  | 0) || 0,
    viewportHeight: (window.innerHeight | 0) || 0,
    screenWidth:    (screen && screen.width  | 0) || 0,
    screenHeight:   (screen && screen.height | 0) || 0,
    devicePixelRatio: Number((window.devicePixelRatio || 1).toFixed(2)),

    deviceMemoryGB: supports('deviceMemory') ? Number(navigator.deviceMemory) || null : null,
    connection: collectConnection(),
    visibilityState: (document && document.visibilityState) || 'visible'
  };
  return c;
}

function collectConnection() {
  if (!supports('connection')) return null;
  const c = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  if (!c) return null;
  return {
    t:  c.type || '',                      // 'wifi','cellular',...
    et: c.effectiveType || '',             // '4g','3g','slow-2g'
    dl: typeof c.downlink === 'number' ? c.downlink : null,
    rtt: typeof c.rtt === 'number' ? c.rtt : null,
    sd: c.saveData ? 1 : 0
  };
}

function collectUaHints() {
  if (!supports('userAgentData')) return null;
  const u = navigator.userAgentData;
  return {
    mob: u.mobile ? 1 : 0,
    plat: u.platform || '',
    // brands is a short array of {brand, version}; we only need the highest-
    // entropy entry, which is usually the last (the real browser). The server
    // does the actual parsing — we just hand off whatever the UA tells us.
    brands: Array.isArray(u.brands) ? u.brands.slice(0, 8).map((b) => ({ b: b.brand, v: b.version })) : []
  };
}

function getLocale() {
  return safely(() => navigator.language || (navigator.languages && navigator.languages[0]) || '') || '';
}

function getTimezone() {
  return safely(() => Intl.DateTimeFormat().resolvedOptions().timeZone) || '';
}
